'use client'

import { useSession } from '@rewardops/auth'

export function AgentImpersonationBanner() {
  const { data: session } = useSession()

  const agent = session?.user?.agent
  const member = session?.user?.member

  if (!agent || !member) return null

  return (
    <div className="bg-[#1C1C1C] px-4 py-1.5 text-center text-sm text-white">
      Agent {agent.name} - you are impersonating user{' '}
      {member.firstName.toUpperCase()} {member.lastName.toUpperCase()} (
      {member.segmentCode}_{member.id})
    </div>
  )
}
